module.exports = __webpack_public_path__ + "img/ic_search.e260c809.svg";